import { render, staticRenderFns } from "./FileDownloadIcon.vue?vue&type=template&id=531cdfdc&scoped=true&"
import script from "./FileDownloadIcon.vue?vue&type=script&lang=js&"
export * from "./FileDownloadIcon.vue?vue&type=script&lang=js&"
import style0 from "./FileDownloadIcon.vue?vue&type=style&index=0&id=531cdfdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531cdfdc",
  null
  
)

export default component.exports